export const KycType = {
  PERSONAL: "PERSONAL",
  BUSINESS: "BUSINESS",
} as const;

export type KycType = (typeof KycType)[keyof typeof KycType];

export const KycStatus = {
  DRAFT: "DRAFT",
  PENDING: "PENDING",
  UNDER_REVIEW: "UNDER_REVIEW",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  NEEDS_MORE_INFO: "NEEDS_MORE_INFO",
} as const;

export type KycStatus = (typeof KycStatus)[keyof typeof KycStatus];

export const KycDocumentType = {
  GOVERNMENT_ID: "GOVERNMENT_ID",
  SELFIE_WITH_ID: "SELFIE_WITH_ID",
  PROOF_OF_ADDRESS: "PROOF_OF_ADDRESS",
  ADDITIONAL_ID: "ADDITIONAL_ID",
  SOURCE_OF_FUNDS: "SOURCE_OF_FUNDS",
  BANK_REFERENCE: "BANK_REFERENCE",
  INCOME_PROOF: "INCOME_PROOF",
  BUSINESS_REG_CERT: "BUSINESS_REG_CERT",
  DIRECTOR_ID: "DIRECTOR_ID",
  DIRECTOR_SELFIE: "DIRECTOR_SELFIE",
  TAX_CLEARANCE: "TAX_CLEARANCE",
  BUSINESS_BANK_STATEMENT: "BUSINESS_BANK_STATEMENT",
  BUSINESS_ADDRESS_PROOF: "BUSINESS_ADDRESS_PROOF",
  AUDITED_FINANCIALS: "AUDITED_FINANCIALS",
  TRADE_LICENSE: "TRADE_LICENSE",
  BENEFICIAL_OWNERSHIP: "BENEFICIAL_OWNERSHIP",
} as const;

export type KycDocumentType =
  (typeof KycDocumentType)[keyof typeof KycDocumentType];

export interface DocumentUpload {
  id: string;
  name: string;
  type: KycDocumentType;
  file: File | null;
  preview: string | null;
  url: string | null;
  mimeType?: string | null;
  status: "pending" | "uploading" | "uploaded";
  metadata?: {
    originalName?: string;
    size?: number;
  };
}

// export interface FormData {
//   address: string | null;
//   city: string | null;
//   country: string | null;
//   dateOfBirth: string | null;
//   fullName: string | null;
//   nationality: string | null;
//   phoneNumber: string | null;
//   postalCode: string | null;
//   state: string | null;
// }

export type KycFormData = PersonalKycFormData | BusinessKycFormData;

export interface PersonalKycFormData {
  fullName: string;
  dateOfBirth: string;
  nationality: string;
  phoneNumber: string;
  dialCode: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;
}

export interface KycUser {
  id: string;
  firstName: string;
  lastName: string;
  role: string;
  email: string;
  phoneNumber: string;
}

export interface SubmittedDocument {
  id: string;
  documentUrl: string;
  status: any;
  documentType: string;
  rejectionReason: string;
  submissionId: string;
  updatedAt: string;
  createdAt: string;
  metadata?: {
    originalName?: string;
    size?: number;
  };
}

export interface FormData {
  fullName: string;
  dateOfBirth: string;
  nationality: string;
  phoneNumber: string;
  dialCode: string;
  address: string;
  city: string;
  state: string;
  country: string;
  postalCode: string;

  // BUSINESS
  businessName: string;
  registrationNumber: string;
  businessType: string;
  taxId: string;
  website: string;
  businessAddress: string;
  businessCity: string;
  businessState: string;
  businessCountry: string;
  directorName: string;
  directorIdNumber: string;
}

export interface BusinessKycFormData {
  businessName: string;
  registrationNumber: string;
  businessType: string;
  taxId: string;
  website: string;
  businessAddress: string;
  businessCity: string;
  businessState: string;
  businessCountry: string;
  directorName: string;
  directorIdNumber: string;
}

export interface KycReviewMeta {
  approvedAt?: string;
  rejectedAt?: string;
  reviewedAt?: string;
}

export type KycSubmission = {
  id: string;
  userId: string;
  kycType?: KycType;
  level: number;
  attempt: number;
  status: KycStatus;
  user: {
    id: string;
    firstName: string;
    lastName: string;
    role: string;
    email: string;
    phoneNumber: string;
    country: {
      id: string;
      name: string;
    };
  };
  reviewedBy: KycUser;
  country: {
    id: string;
    name: string;
  };
  nationality: {
    id: string;
    name: string;
  };
  reviewMeta?: KycReviewMeta | null;
  formData: {
    formData: FormData;
  };
  reviewedById?: string | null;
  reviewNote?: string | null;
  documents: SubmittedDocument[];
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
};

export interface ArrayMeta {
  hasNextPage: boolean;
  hasPrevPage: boolean;
  limit: number;
  page: number;
  total: number;
  totalPages: number;
}

export interface KycSubmissionInterface {
  data: KycSubmission[];
  meta: ArrayMeta;
}
